import { Navigate, Outlet, useLocation } from "react-router-dom"

import { Logomark } from "@/components/layout/Logotype"
import { useAuth } from "@/lib/auth"
import { t } from "@/lib/i18n"

/**
 * Verificacion de sesion. No es un spinner mudo: dice que se esta haciendo,
 * porque en el arranque en frio con Firebase esto puede tardar un segundo y
 * una pantalla vacia parece una pantalla rota.
 *
 * Aqui todavia no hay sociedad activa, asi que tampoco hay idioma de sociedad:
 * la frase va en espanol y sin `useVoz()`. Es el unico sitio del producto donde
 * eso es correcto — el idioma sigue al pais de la sociedad, y a esta altura no
 * se sabe cual es.
 */
export function RequireAuth() {
  const { profile, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-3 bg-background">
        <Logomark className="h-7 w-7 animate-pulse [animation-duration:1.6s]" />
        <div className="text-center">
          <p className="titular text-sm">{t("Marty está abriendo tu escritorio…")}</p>
          <p className="mt-0.5 text-2xs text-muted-foreground">
            {t("Resolviendo tu rol, tu alcance y tus capacidades.")}</p>
        </div>
      </div>
    )
  }

  if (!profile) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <Outlet />
}
